import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import Dropzone from "core/Dropzone";

import HeadingSection from "./HeadingSection";
import Footer from "./Footer";

import { UploadsSectionContainer, DropzoneContainer } from "./styles";

import { useDropzone, DropzoneProvider } from "frontend/hooks/useDropzone";

import { desktopHeaderHeight } from "core/SiteHeader/constants";
import { SHOOT_TYPE_INDIVIDUAL, SHOOT_TYPE_PHOTOSHOOT } from "./constants";

const PhotoUploadContainer = ({ initiallySelectedRadio, shootName }) => {
    const [hasHeaderHeight, updateHeaderHeight] = useState(desktopHeaderHeight);
    const [hasShootName, updateShootName] = useState(shootName);
    const [isSelectAll, updateSelectAll] = useState(false);
    const [selectedRadio, updateSelectedRadio] = useState(
        initiallySelectedRadio
    );

    const radioOptions = [
        {
            value: SHOOT_TYPE_INDIVIDUAL,
            label: "Individual photos"
        },
        {
            value: SHOOT_TYPE_PHOTOSHOOT,
            label: "Photo shoot"
        }
    ];

    const allowedUploadNum = 10; // TODO in future PR: replace with tier limit from endpoint when ready

    const isPhotoshootType = selectedRadio === SHOOT_TYPE_PHOTOSHOOT;
    const siteHeader = document.getElementById("site-header");

    const dropzoneProps = useDropzone({
        initialMaximumFiles: allowedUploadNum
    });

    const {
        hasAcceptedFiles,
        handleOpenFilePicker,
        minFileSizeBytes,
        maxFileSizeBytes,
        hasRejectedFileErrors,
        handleClearErrors,
        rejectedFilesCount
    } = dropzoneProps;

    const hasAddedPhotos = hasAcceptedFiles && hasAcceptedFiles.length > 0;

    const handleRadioOnClick = val => {
        updateSelectedRadio(val);
    };

    const handleSelectAll = () => {
        updateSelectAll(!isSelectAll);
        // todo in future PR: select all photos in grid
    };

    const handleScroll = () => {
        updateHeaderHeight(siteHeader.offsetHeight);
    };

    // grab header height to pass to sticky footer:
    useEffect(() => {
        if (siteHeader) {
            handleScroll;

            window.addEventListener("scroll", handleScroll);

            return () => {
                window.removeEventListener("scroll", handleScroll);
            };
        }
    }, [updateHeaderHeight, siteHeader, handleScroll]);

    return (
        <>
            <UploadsSectionContainer
                topSpacing="2xl"
                bottomSpacing="none"
                hasHeaderHeight={hasHeaderHeight}
            >
                <HeadingSection
                    hasAcceptedFiles={hasAcceptedFiles}
                    hasAddedPhotos={hasAddedPhotos}
                    isPhotoshootType={isPhotoshootType}
                    hasShootName={hasShootName}
                    allowedUploadNum={allowedUploadNum}
                    radioOptions={radioOptions}
                    handleRadioOnClick={handleRadioOnClick}
                    selectedRadio={selectedRadio}
                    updateShootName={updateShootName}
                    handleSelectAll={handleSelectAll}
                    isSelectAll={isSelectAll}
                />

                <DropzoneContainer>
                    <Dropzone {...dropzoneProps} />
                </DropzoneContainer>
            </UploadsSectionContainer>

            <Footer
                hasAcceptedFiles={hasAcceptedFiles}
                handleOpenFilePicker={handleOpenFilePicker}
                hasHeaderHeight={hasHeaderHeight}
                minFileSizeBytes={minFileSizeBytes}
                maxFileSizeBytes={maxFileSizeBytes}
                hasRejectedFileErrors={hasRejectedFileErrors}
                handleClearErrors={handleClearErrors}
                rejectedFilesCount={rejectedFilesCount}
            />
        </>
    );
};

const PhotoUpload = ({
    initiallySelectedRadio = SHOOT_TYPE_INDIVIDUAL,
    shootName = "Add Name"
}) => {
    return (
        <DropzoneProvider>
            <PhotoUploadContainer
                initiallySelectedRadio={initiallySelectedRadio}
                shootName={shootName}
            />
        </DropzoneProvider>
    );
};

PhotoUpload.propTypes = {
    initiallySelectedRadio: PropTypes.oneOf([
        SHOOT_TYPE_INDIVIDUAL,
        SHOOT_TYPE_PHOTOSHOOT
    ]),
    shootName: PropTypes.string
};

export default PhotoUpload;
